module.exports = __webpack_public_path__ + "img/home_adapt_personal_normal.9857805c.svg";